import { Roles } from "../../../../auth/rolesPermissions";

export function buildOrderPayload({state, userContext, language, logic, profile}) {
    const orderInfo = state.data.orderInfo || {};
    const recipient = state.data.recipient || {};

    const recipientName = String(recipient.name || "").trim();
    const recipientSurname = String(recipient.surname || "").trim();
    const hasRecipientSurname = recipientSurname.length > 0;
    const deliveryBusinessName = hasRecipientSurname ? null : recipientName;

    const deliveryName = hasRecipientSurname
            ? `${recipientName} ${recipientSurname}`.trim()
            : null;

    const firstProduct = state.selectedProducts[0] || {};
    const orderCodes = logic.normalizeOrderCodes(firstProduct);
    const scnu = firstProduct.SCNU || "";
    const dealerCode = orderCodes.dealerCode || "";

    const bcnu = orderCodes.BCNU ||
        `${dealerCode}_${orderInfo.orderReference}` ||
        "";

    const ownerCode = orderCodes.ownerCode ||
        (bcnu && scnu ? `${bcnu}-${scnu}` : "");

    const deliveryCode = String(
        recipient.recipientCode ||
        recipient.RecipientCode ||
        ""
    ).trim();

    const orderNumber = logic.buildOrderNumber(
        orderInfo.orderReference,
        dealerCode,
        userContext.userRole
    );

    return {
        APIKey: "",
        APISecret: "",
        Data: {
            Number: orderNumber,
            Date: new Date().toISOString(),
            DeliveryDate: new Date().toISOString(),

            DealerCode: dealerCode,
            BCNU: bcnu,
            SCNU: scnu,
            OwnerCode: ownerCode,
            SendLabel: !!state.data.sendLabel,

            customerCode: bcnu || dealerCode || "",
            customerBusinessName: "sendapro",
            customerAddress: "",
            customerPlace: "",
            customerPostalCode: "",
            customerZone: "",
            customerCountry: "",
            customerPhone: "",
            customerEmail: "",

            deliveryCode,
            deliveryBusinessName,
            deliveryName,

            deliveryAddress: recipient.address || "",
            deliveryPlace: recipient.city || "",
            deliveryPostalCode: recipient.zip || "",
            deliveryZone: recipient.province || "",
            deliveryCountry: recipient.country || "",
            deliveryPhone: recipient.mobile || "",
            deliveryEmail: recipient.email || "",

            orderType: state.orderType,
            paymentMethod: "altro",
            shippingMethod: "S",
            shippingAmount: 0,

            carrierCode: profile.getCarrierCode({
                orderType: state.orderType,
                customerPickup: state.customerPickup
            }),

            annotations:
                String(orderInfo.notes || "").trim() || "-",

            language: language.toUpperCase(),

            orderDetails: state.selectedProducts.map(
                (product, index) => {
                    const orderDetail = {
                        lineNumber: index + 1,
                        SKU: product.SKU || "",
                        description: product.description || "",
                        lot: "",

                        quantity: parseInt(
                            product.quantity || 0,
                            10
                        ),

                        weight: parseFloat(
                            String(product.weight || "0")
                                .replace(",", ".")
                        ),

                        volume: parseFloat(
                            String(product.volume || "0")
                                .replace(",", ".")
                        ),

                        unitPrice: parseFloat(
                            String(product.unitPrice || "0")
                                .replace(",", ".")
                        ),

                        originalPrice: parseFloat(
                            String(product.originalPrice || "0")
                                .replace(",", ".")
                        ),

                        discount: parseFloat(
                            String(product.discount || "0")
                                .replace(",", ".")
                        ),

                        voucher: parseFloat(
                            String(product.voucher || "0")
                                .replace(",", ".")
                        ),

                        annotations: product.annotations || "",
                        SORD: product.SORD || "",
                        CNUM: product.CNUM || ""
                    };

                    if (
                        userContext.userRole ===
                        Roles.WAREHOUSEADMIN
                    ) {
                        orderDetail.SSCC = product.SSCC || "";
                    }

                    return orderDetail;
                }
            )
        }
    };
}